module.exports = __webpack_public_path__ + "img/balkon.d1c4959a.jpg";